import { Skeleton } from "antd";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Autoplay, Pagination } from "swiper/modules";
import "./GiftGridSection.css";
import GiftImg1 from "../../assets/img/gift-banner/birthday-banner.jpg"
import GiftImg2 from "../../assets/img/gift-banner/cake-banner.jpg"
import GiftImg3 from "../../assets/img/gift-banner/combo-banner.jpg"
import GiftImg4 from "../../assets/img/gift-banner/wedding-banner.jpg"
export default function GiftSwiperSection({ bannerData, isLoading }) {
  return (
    <section className="pb-4 mt-4 section-spacing-x gift-swiper-section">
      {/* {isLoading === true ? */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 mx-auto text-center main-heading-box">
            <h2 className="main-heading">Special Presents</h2>
            <p>
              Celebrate milestones with extraordinary presents that leave a
              lasting impression
            </p>
          </div>
        </div>
        <div className="row">
          <Swiper
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            slidesPerView={1.3}
            spaceBetween={20}
            autoplay="false"
            // autoplay={{
            //   delay: 2500,
            //   disableOnInteraction: false,
            // }}
            breakpoints={{
              640: {
                slidesPerView: 1.3,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
            }}
            modules={[Autoplay, Pagination]}
            className="mySwiper pb-4 pb-lg-5 swiper-slide-height">
            <SwiperSlide>
              <Link to="/category/birthday">
                <img alt="Birthday" src={GiftImg1} className="img-fluid" />
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/category/cakes">
                <img alt="Birthday" src={GiftImg2} className="img-fluid" />
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/category/combos">
                <img alt="Birthday" src={GiftImg3} className="img-fluid" />
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/category/occassion">
                <img alt="Birthday" src={GiftImg4} className="img-fluid" />
              </Link>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      {/* // : <div className="container-fluid">
      //   <div className="row">
      //     <div className="col-lg-6 mx-auto text-center main-heading-box">
      //       <h2 className="main-heading">Special Presents</h2>
      //       <p>
      //         Celebrate milestones with extraordinary presents that leave a lasting impression
      //       </p>
      //     </div>
      //   </div>
      //   <div className="row gift-imgs gift-imgs-skeleton">
      //     <div className="col-lg-3 mb-3 mb-lg-0">
      //       <Skeleton.Image
      //         className="img-fluid w-100 h-100"
      //       />
      //     </div>
      //     <div className="col-lg-6 mb-3 mb-lg-0 pe-lg-0">
      //       <div className="row">
      //         <div className="col-6 ps-lg-0">
      //           <Skeleton.Image
      //             className="img-fluid w-100 h-100 aspect-ratio"
      //           />
      //         </div>
      //         <div className="col-6 ps-lg-0">
      //           <Skeleton.Image
      //             className="img-fluid w-100 h-100 aspect-ratio"
      //           />
      //         </div>
      //         <div className="col-12 mt-3 mt-lg-2 pt-lg-1 ps-lg-0">
      //           <Skeleton.Image
      //             className="img-fluid img-right-mid w-100"
      //           />
      //         </div>
      //       </div>
      //     </div>
      //     <div className="col-lg-3">
      //       <div className="row">
      //         <div className="col-6 col-lg-12">
      //           <Skeleton.Image
      //             className="img-fluid w-100 img-right"
      //           />
      //         </div>
      //         <div className="col-6 col-lg-12 pt-lg-1 mt-lg-2">
      //           <Skeleton.Image
      //             className="img-fluid w-100 img-right-two"
      //           />
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>} */}
    </section>
  );
}
